import { IconCheck } from 'icons';
import BasicMarker from '../BasicMarker/BasicMarker';
import { BasicMarkerStyle } from '../BasicMarker/BasicMarkerStyle';

const CheckInMarker = ({ color='#0090fe', text, subText, textColor, wrapperSize = '40', iconSize = '24' }) => {

    const classes = BasicMarkerStyle();
    return (
        <BasicMarker
            color={color}
            text={text}
            subText={subText}
            textColor={textColor}
            wrapperSize={wrapperSize}
            icon={<IconCheck fill='white' height={iconSize} width={iconSize} className={classes.lotIcon} />}
        />
    )
}
export default CheckInMarker;
